import { OEmbed } from '../OEmbed'
import { BeWizrModel } from './BeWizrModel'

export abstract class BeWizrMiscItemBase extends BeWizrModel {

  title!: string
  type!: 'embeditem' | 'mediaitem' | 'linkitem'

  links!: {
    image: string | null
  }

  shortDescription!: string | null
  descriptionHtml!:  string | null

}

export class BeWizrLinkItem extends BeWizrMiscItemBase {
  type!:        'linkitem'
  externalUrl!: string
  openGraphJson!: {
    title:       string | null
    description: string | null
    image:       string | null
  } | null
}

export class BeWizrEmbedItem extends BeWizrMiscItemBase {
  type!:      'embeditem'
  embedUrl!:  string
  embedJson!: OEmbed
}

export class BeWizrMediaItem extends BeWizrMiscItemBase {
  type!:        'mediaitem'
  images!:      string[]
  attachments!: string[]
}